<template>
  <div>
    <va-modal
      class="modal"
      v-model="showModal"
      max-width="100%"
      :hideDefaultActions="true"
      noEscDismiss
      noOutsideDismiss
      title="Gestion de l'action"
    >
      <div class="forcewidth">
        <div class="row row-inside">
          <div class="flex md12" v-if="identreprise && isready">
            <va-input
              label="entreprise"
              disabled
              v-model="entreprise.nom"
            ></va-input>
          </div>
          <div class="flex md12" v-if="!identreprise && isready">
            <va-select
              label="Selection de l'entreprise"
              key-by="identreprise"
              text-by="nom"
              :options="listeEntreprise"
              placeholder="Selection de l'entreprise"
              v-model="identrepriseSelect"
              searchable
            />
          </div>
          <div class="flex md12 pa-2">Créé par : {{ utilisateur }}</div>
          <div class="flex md6">
            <va-date-picker
              :config="{ dateFormat: 'd-m-Y' }"
              label="Date de l'action"
              v-model="dateAction"
            />
          </div>

          <div class="flex md12 my-4">
            <va-input
              v-model="comment"
              label="Description:"
              type="textarea"
              autosize
              :minRows="8"
              :maxRows="8"
            />
          </div>
          <div class="flex md2">
            <va-button
              v-if="idaction"
              class="fullwidth"
              color="danger"
              @click="showConfirmDelete = true"
              >Supprimer</va-button
            >
          </div>
          <div class="flex md2 offset--md5">
            <va-button class="fullwidth" color="info" @click="closeModal"
              >Annuler</va-button
            >
          </div>
          <div class="flex md2">
            <va-button class="fullwidth" color="success" @click="createAction"
              >Sauvegarder</va-button
            >
          </div>
        </div>
      </div>
    </va-modal>
    <va-modal
      :style="{ 'z-index': '1500' }"
      class="modal"
      title="Confirmer la suppression"
      v-model="showConfirmDelete"
      message="Voulez vous vraiment supprimer cette action?"
      cancelClass="none"
      okText="Supprimer"
      cancelText="Annuler"
      max-width="100%"
      v-on:ok="deleteAction()"
    />
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
export default {
  name: "gestion-action",
  props: ["value", "identreprise", "idaction"],
  data() {
    return {
      showConfirmDelete: false,
      entreprise: null,
      showModal: false,
      identrepriseSelect: "",
      listeEntreprise: [],
      isready: false,
      dateAction: moment().format("DD-MM-YYYY"),
      utilisateur:
        this.$store.getters.user.prenom + " " + this.$store.getters.user.nom,
      comment: "",
    };
  },
  mounted() {
    this.showModal = this.value; // initialize internal variables
  },
  computed: {},
  watch: {
    value(newValue) {
      // Parent property changed; update internal variables
      if (newValue === true) {
        this.loadInfos();
      }
      this.showModal = this.value;
    },
    closeModal() {
      this.resetAction();
      this.$emit("close", false);
      this.$emit("input", false);
    },
  },
  created() {},
  methods: {
    closeModal() {
      this.$emit("close", false);
      this.$emit("input", false);
    },
    async getListEntreprises() {
      try {
        let res = await axios.get("/api/retours/liste-entreprises-action");

        this.listeEntreprise = res.data.listeEntreprise;
        console.log(this.listeEntreprise);
        this.isready = true;
      } catch (error) {
        console.log(error);
        this.launchToast("Erreur lors du chargement");
      }
    },
    async getAction() {
      try {
        let res = await axios.get("api/retours/action", {
          params: { idaction: this.idaction },
        });
        // fill infos
        let action = res.data;
        this.listeEntreprise = [];
        this.identrepriseSelect = "";
        this.dateAction = moment(action.date_action, "YYYY-MM-DD").format(
          "DD-MM-YYYY"
        );
        this.comment = action.commentaire;
        this.entreprise = {
          identreprise: action.identreprise,
          nom: action.nom_entreprise,
        };
        this.isready = true;
      } catch (error) {
        console.log(error);
        this.launchToast("Erreur lors du chargement");
      }
    },
    async getInfosEntreprise() {
      try {
        let res = await axios.get("api/retours/infos-entreprise", {
          params: { identreprise: this.identreprise },
        });

        this.entreprise = res.data;
        this.isready = true;
      } catch (error) {
        console.log(error);
        this.launchToast("Erreur lors du chargement");
      }
    },
    async deleteAction() {
      try {
        let actionRaw = await axios.delete("/api/retours/action", {
          params: { idaction: this.idaction },
        });
        this.$emit("update", actionRaw.data);
        this.closeModal();
      } catch (error) {
        console.log(error);
        this.launchToast("Erreur lors de la suppression");
      }
    },
    async createAction() {
      try {
        if (this.entreprise) {
          this.identrepriseSelect = {
            identreprise: this.entreprise.identreprise,
          };
        }

        if (!this.identrepriseSelect) {
          this.launchToast("Entreprise non selectionnée");
          return;
        }

        if (!this.dateAction) {
          this.launchToast("Date non renseignée");
          return;
        }

        if (!this.comment) {
          this.launchToast("Description non renseignée");
          return;
        }

        let action = {
          identreprise: this.identrepriseSelect.identreprise,
          date_action: moment(this.dateAction, "DD-MM-YYYY").format(
            "YYYY-MM-DD"
          ),
          commentaire: this.comment,
        };

        // modification ou creation
        if (this.idaction) {
          action.idaction_retour_entreprise = this.idaction;
          let newAction = await axios.put("/api/retours/update-action", {
            action: action,
          });
          newAction.data.hist_type = "action";
          this.$emit("update", newAction.data);
        } else {
          //creation
          let newAction = await axios.post("/api/retours/action", {
            action: action,
          });
          this.$emit("new", newAction.data);
        }
        this.closeModal();
      } catch (error) {
        console.log(error);
        this.launchToast("Erreur lors du chargement");
      }
    },
    resetAction() {
      this.entreprise = null;
      this.isready = false;
      this.listeEntreprise = [];
      this.identrepriseSelect = "";
      this.dateAction = moment().format("DD-MM-YYYY");
      this.comment = "";
    },
    loadInfos() {
      this.resetAction();
      if (this.idaction) {
        this.getAction();
        return;
      } else if (this.identreprise) {
        this.getInfosEntreprise();
        return;
      } else {
        this.getListEntreprises();
        return;
      }
    },
    launchToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.forcewidth {
  width: 40vw;
  overflow: auto;
}

.fullwidth {
  width: 95%;
}
</style>
